<nav  class="navbar navbar-expand-sm bgx navbar-light scrolling-navbar fixed-top navbar-style">

    <a [routerLink]="['/']">
    <img class="navbar-brand" src="assets/img/Logonew.png" />
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02"
      aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link nav-barlink" [routerLink]="['/']">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-barlink" href="#tentang-kami">
            <!-- <img class="icon" src="assets/img/login.png"> -->
            Tentang Kami
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-barlink" [routerLink]="['/hubungi-kami']">
            <!-- <img class="icon" src="assets/img/help.png"> -->
            Hubungi Kami
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-barlink"
            href="https://buyer.sukandaonelink.com/">
            <!-- <img class="icon" src="assets/img/contact-us.png"> -->
            Login
          </a>
        </li>
        <form class="form-inline my-2 my-lg-0">
          <button class="btn btn-sol" style="display:none" [routerLink]="['/register']">
            Daftar Sekarang
          </button>
          <button class="btn btn-sol" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">Aktifasi
          </button>
        </form>
        <li class="nav-item">

        </li>
      </ul>
    </div>

  </nav>
